import { AnalyticsStrategy } from './AnalyticsStrategy';
import { MixpanelProvider } from './MixpanelProvider';
import { GTMProvider } from './GTMProvider';
import { FacebookProvider } from './FacebookProvider';
import { MockProvider } from './MockProvider';
import { AnalyticsProvider } from './AnalyticsProvider';
import { isPOW } from '../config/utils';

export type EventQueueItem = {
  eventName: string,
  eventProperties?: Record<string, any>,
  additionalProperties?: Record<string, any>,
};

const isTestEnv = typeof process !== 'undefined' && process.env.JEST_WORKER_ID;

export const mockAnalyticsProvider = isTestEnv ? new MockProvider() : null;

const providers: AnalyticsProvider[] = isTestEnv
  ? [mockAnalyticsProvider]
  : [
    new MixpanelProvider(),
    new GTMProvider(),
    !isPOW() && new FacebookProvider()
  ];

export const analyticsService = new AnalyticsStrategy(providers);
